interface ValidationError {
  min?: string
  max?: string
};

export const useInputRangeErrors = (min: Ref<number | undefined>, max: Ref<number | undefined>) => {
  const { t } = useI18n();
  const focusedInput = ref<'max' | 'min'>('min');

  const errors = computed<ValidationError>(() => {
    const validationError: ValidationError = {};

    if (!min.value || !max.value) return validationError;
    if (min.value > max.value) {
      if (focusedInput.value === 'max') {
        validationError.max = t(`property_serp.filters.error_max`);
      }
      else if (focusedInput.value === 'min') {
        validationError.min = t(`property_serp.filters.error_min`);
      }
    }
    return validationError;
  });

  return {
    focusedInput,
    errors,
  };
};
